module.exports = __webpack_public_path__ + "static/img/icon-success.584e0ccf.png";